import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import api, { formatApiError } from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';

export default function AccountingSettings() {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/tenant/accounting/settings');
      setSettings(data || {});
    } catch (e) {
      toast.error(formatApiError(e, 'Gagal memuat pengaturan'));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const saveSettings = async (patch) => {
    try {
      const { data } = await api.patch('/tenant/accounting/settings', patch);
      setSettings(data);
      toast.success('Pengaturan disimpan');
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Gagal simpan');
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-20">
        <div className="h-8 w-8 animate-spin rounded-full border-b-2 border-[#2D6CDF]" />
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="accounting-settings-page">
      <Card className="border-slate-200 shadow-sm">
        <CardHeader>
          <CardTitle className="text-lg">Posting otomatis</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-start gap-4 rounded-xl border border-slate-100 bg-slate-50/50 p-4">
            <Switch
              checked={!!settings.auto_post_on_order_paid}
              onCheckedChange={(v) => saveSettings({ auto_post_on_order_paid: v })}
            />
            <div>
              <Label className="text-base font-semibold text-slate-900">Jurnal saat pesanan lunas</Label>
              <p className="mt-1 text-sm text-slate-500">
                Otomatis buat jurnal (Dr Kas, Cr Pendapatan) ketika status pembayaran pesanan menjadi lunas.
              </p>
            </div>
          </div>
          <p className="text-sm text-slate-600">
            Laporan penjualan dari transaksi (bukan buku besar):{' '}
            <Link className="font-medium text-[#2D6CDF] underline" to="/dashboard/finance-reports">
              Finance Reports
            </Link>
            .
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
